import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const EASE = [0.16, 1, 0.3, 1];

const TYPE_PARAM = { player: "player", club: "community", academy: "academy" };

const fadeUp = {
  initial: { opacity: 0, y: 26 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
};

const ROLES = [
  { id: "player", title: "Player", sub: "For the ones on the pitch" },
  {
    id: "club",
    title: "Football Community / Club",
    sub: "For the ones building the game locally",
  },
  { id: "academy", title: "Academy", sub: "For the ones developing talent" },
];

export default function KickOff() {
  return (
    <section
      id="kick-off"
      data-testid="kick-off"
      className="relative z-20 border-t border-[#2A2A2A] bg-[#0B0B0B] pt-20 md:pt-28 pb-14 md:pb-16"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 items-start gap-12 lg:grid-cols-2 lg:gap-16">
          {/* Left — copy */}
          <div>
            <motion.span
              {...fadeUp}
              transition={{ duration: 0.8, ease: EASE }}
              className="mb-7 flex items-center gap-3"
            >
              <span className="h-2 w-2 rounded-full bg-[#1F7A4D]" />
              <span className="font-body text-xs md:text-sm font-medium tracking-[0.3em] uppercase text-[#B3B3B3]">
                Early Access
              </span>
            </motion.span>

            <motion.h2
              {...fadeUp}
              transition={{ duration: 0.9, ease: EASE, delay: 0.05 }}
              data-testid="kick-off-heading"
              className="font-display uppercase text-white text-5xl md:text-6xl lg:text-7xl leading-[0.88] tracking-[0.01em]"
            >
              Kick Off
              <br />
              With Us<span className="text-[#1F7A4D]">.</span>
            </motion.h2>

            <motion.div
              {...fadeUp}
              transition={{ duration: 0.9, ease: EASE, delay: 0.12 }}
              className="mt-8 max-w-[52ch] space-y-4 font-body text-lg font-light leading-relaxed text-[#B3B3B3]"
            >
              <p>
                The next chapter of grassroots football starts with the people
                who believe in it first.
              </p>
              <p>
                Join today to get early access, platform updates and
                opportunities to help shape The Football Collective.
              </p>
            </motion.div>
          </div>

          {/* Right — selection panel */}
          <motion.div
            {...fadeUp}
            transition={{ duration: 0.9, ease: EASE, delay: 0.16 }}
          >
            <p className="font-body text-xs font-medium uppercase tracking-[0.3em] text-[#B3B3B3]">
              I Am A
            </p>
            <div
              data-testid="role-selection"
              className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3"
            >
              {ROLES.map((role) => (
                <Link
                  key={role.id}
                  to={`/register?type=${TYPE_PARAM[role.id]}`}
                  data-testid={`role-${role.id}`}
                  className="flex h-full flex-col border border-[#2A2A2A] bg-[#0B0B0B] p-6 text-left transition-colors duration-300 outline-none hover:border-[#1F7A4D] hover:bg-[#151515] focus-visible:border-[#1F7A4D]"
                >
                  <span className="font-display uppercase text-white text-2xl leading-[0.95] tracking-[0.02em]">
                    {role.title}
                  </span>
                  <span className="mt-3 font-body text-sm font-light leading-relaxed text-[#B3B3B3]">
                    {role.sub}
                  </span>
                </Link>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
